import { render } from "./AddRule.vue?vue&type=template&id=5588cbfd&ts=true"
import script from "./AddRule.vue?vue&type=script&lang=ts"
export * from "./AddRule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__